import React, { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import {
  Title,
  LeftSide,
  Column,
  Back,
  InputContainer,
  UnderlineText,
  Inputs,
  StyledInput,
  Icon,
  StyledColumn,
  StyledText,
} from './RecoveryCodePage.styles';
import Button from '../../../components/utils/Button/Button';
import { ReactComponent as Logo } from '../../../assets/icons/logoBlack.svg';
import { ReactComponent as LeftChevron } from '../../../assets/icons/chevronLeft.svg';
import { useNavigate } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import MainContainer from '../../../components/MainContainer/MainContainer';
import { useDispatch, useSelector } from 'react-redux';
import { changePassword, renewCodeForVendor } from '../../../store/slice/auth/asyncThunks';
import { selectChangePasswordPending, selectEmailInput } from '../../../store/slice/auth/slice';
import { toast } from 'react-toastify';
import { RENEW_CODE_TYPE } from '../../../utils/constants';
import { isValidPassword } from '../../../utils/utils';

const RecoveryCodePage = () => {
  const [otp, setOtp] = useState('');
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const email = useSelector(selectEmailInput);
  const loading = useSelector(selectChangePasswordPending);
  const [visibility, setVisibility] = useState(true);
  const [visibility2, setVisibility2] = useState(true);
  // const [isPasswordValid, setIsPasswordValid] = useState(false);
  // const [isConfirmPasswordValid, setIsConfirmPasswordValid] = useState(false);
  const [arePasswordsMatching, setArePasswordsMatching] = useState(false);
  const [timer, setTimer] = useState(60);
  const [canResendCode, setCanResendCode] = useState(true);
  const [timerText, setTimerText] = useState('60 seconds');

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
        setTimerText(`${timer - 1} seconds`);
      }, 1000);
    } else {
      setCanResendCode(true);
      setTimerText('Resend Code');
    }

    return () => clearInterval(interval);
  }, [timer]);

  const handleResendCode = () => {
    dispatch(renewCodeForVendor({ email, type: RENEW_CODE_TYPE.FORGOT_PASSWORD }));
    setTimer(60);
    setTimerText('60 seconds');
    setCanResendCode(false);
  };

  const startTimer = () => {
    if (canResendCode) {
      setTimer(60);
      setCanResendCode(false);
    }
  };

  useEffect(() => {
    startTimer();
  }, []);

  // const validatePassword = password => {
  //   return password.length >= 8;
  // };

  const handlePasswordChange = e => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    // setIsPasswordValid(validatePassword(newPassword));
    if (newPassword === confirmPassword) {
      setArePasswordsMatching(true);
    } else {
      setArePasswordsMatching(false);
    }
  };

  const handleConfirmPasswordChange = e => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);
    //setIsConfirmPasswordValid(validatePassword(newConfirmPassword));
    if (newConfirmPassword === password) {
      setArePasswordsMatching(true);
    } else {
      setArePasswordsMatching(false);
    }
  };

  const handleVisibilityChange = () => {
    setVisibility(!visibility);
  };

  const handleVisibilityChange2 = () => {
    setVisibility2(!visibility2);
  };

  const handleContinue = () => {
    if (isValidPassword(password)) {
      dispatch(changePassword({ email, newPassword: password, code: otp }))
        .unwrap()
        .then(() => navigation('/'))
        .catch(err => toast.error(err.message));
    } else {
      toast.error(
        'Password must be min 8 characters, and have 1 Special Character, 1 Uppercase, 1 Number and 1 Lowercase. Special Characters are #?!@$%^&*-',
      );
    }
  };

  return (
    <MainContainer>
      <LeftSide>
        <Logo width={110} height={58} />

        <Column>
          <Back onClick={() => navigation(-1)}>
            <LeftChevron />
          </Back>
          <Title>Recovery code</Title>
        </Column>
        <InputContainer>
          <OtpInput
            containerStyle={{ flexWrap: 'wrap', justifyContent: 'center' }}
            inputStyle={{
              width: 55,
              userSelect: 'none',
              height: 51,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 12,
              fontSize: 18,
              fontFamily: 'Poppins-Medium',
              letterSpacing: -0.2,
              color: '#000',
              borderTopWidth: 0,
              borderLeftWidth: 0,
              borderRightWidth: 0,
              borderBottomWidth: 1,
              outline: 'none',
              borderColor: '#000',
              backgroundColor: '#fff',
            }}
            shouldAutoFocus
            value={otp}
            placeholder={'------'}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span style={{ userSelect: 'none', color: 'transparent' }}>-</span>}
            renderInput={props => <input {...props} />}
          />
          <StyledColumn>
            <UnderlineText onClick={canResendCode ? handleResendCode : null} $timer={canResendCode}>
              Didn't get the code?
            </UnderlineText>
            <StyledText $timer={canResendCode}>{timerText}</StyledText>
          </StyledColumn>

          <Inputs>
            <StyledInput
              placeholder="New Password"
              value={password}
              type={visibility ? 'password' : 'text'}
              rightIcon={
                visibility ? (
                  <Icon onClick={handleVisibilityChange}>🙈</Icon>
                ) : (
                  <Icon onClick={handleVisibilityChange}>🐵</Icon>
                )
              }
              onChange={handlePasswordChange}
            />
            <StyledInput
              rightIcon={
                visibility2 ? (
                  <Icon onClick={handleVisibilityChange2}>🙈</Icon>
                ) : (
                  <Icon onClick={handleVisibilityChange2}>🐵</Icon>
                )
              }
              placeholder="Confirm Password"
              type={visibility2 ? 'password' : 'text'}
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
            />
          </Inputs>
        </InputContainer>

        <Button
          width
          disabled={!arePasswordsMatching || loading}
          loading={loading}
          title={'Continue'}
          onClick={handleContinue}
        />
      </LeftSide>
    </MainContainer>
  );
};

export default RecoveryCodePage;
